import { Container, Divider, Heading, Flex } from '@chakra-ui/react';
import Breadcrumbs from '../../common/Breadcrumbs';
import BatchesUpdateForm from '../../components/client/batches/BatchesUpdateForm';

interface BreadcrumbLink {
  linkName: string;
  linkUrl: string;
}

const BatchesUpdatePage = () => {
  const breadcrumbLinks: BreadcrumbLink[] = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'passes',
      linkUrl: '/passes',
    },
    {
      linkName: 'batches',
      linkUrl: '/passes/batches',
    },
    {
      linkName: 'update',
      linkUrl: '/passes/batches/update',
    },
  ];

  return (
    <Container display="flex" flexDir="column" flex="1" pb={6}>
      <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
      <Flex
        flexDirection={{ base: 'column', sm: 'row' }}
        alignItems="center"
        flexWrap="wrap"
        mt="15px"
        pt="9px"
        minH="54px"
      >
        <Heading alignSelf={{ base: 'flex-start', sm: 'center' }}>
          New Pass Update Batch
        </Heading>
      </Flex>
      <Divider borderColor="primaryBackground" mb={6} />
      <BatchesUpdateForm />
    </Container>
  );
};

export default BatchesUpdatePage;
